import { Info } from 'lucide-react'

import { TextLink } from '@/modules/Frontend/UiBlocks'

import { STIHL_CATEGORY_ID } from '../../../lib'
import { useProductAttributes } from '../../../state'

export function SafetyStihl() {
  const { categories } = useProductAttributes()
  const hasCategory = categories?.some((category) => category.id === STIHL_CATEGORY_ID)

  if (!hasCategory) return null

  const bodyClasses = 'font-main-font text-sm xl:text-base text-center md:text-left text-black leading-5 xl:leading-7 font-normal'
  const headingClasses = 'font-main-font text-base xl:text-lg font-bold text-center md:text-left text-black leading-7'
  const stihlLinkClasses = 'ml-1 font-medium text-stihl-orange hover:text-stihl-orange/80 visited:text-stihl-orange/80 active:text-stihl-orange/80 leading-5 xl:leading-7'

  return (
    <div className="flex flex-col md:flex-row p-4 xl:p-6 items-center gap-4 bg-gray-50">
      <div className="w-full">
        <div className="flex flex-row gap-3 items-center w-full">
          <div className="flex items-center justify-center bg-white p-2 rounded-full">
            <Info className="w-5 h-5 md:w-6 md:h-6 text-black" />
          </div>
          <h3 className={headingClasses}>MASURI DE SIGURANTA</h3>
        </div>
        <p className={bodyClasses}>
          Pentru a cunoaste pericolele utilizarii echipamentelor, va recomandam sa cititi cu atentie
          instructiunile de folosire.
          <br />
          Daca informatiile nu va sunt clare, puteti verifica si canalul de
          <TextLink
            variant="underline"
            className="ml-1 font-normal text-black leading-5 xl:leading-7"
            rel="nofollow"
            href="https://www.youtube.com/user/STIHLRomania"
            external
            title="YouTube STIHL Romania"
          >
            YouTube STIHL Romania
          </TextLink>
          {' '}sau vizitati
          <TextLink
            className={stihlLinkClasses}
            href="https://www.stihl.ro/ro"
            external
            rel="nofollow"
            title="STIHL Romania"
          >
            STIHL Romania
          </TextLink>
        </p>
      </div>

      <div className="w-full mt-2 border-t md:border-t-0 border-gray-200 pt-4 md:pt-0">
        <div className="flex flex-row gap-3 items-center w-full mb-3">
          <div className="flex items-center justify-center bg-white p-2 rounded-full">
            <Info className="w-5 h-5 md:w-6 md:h-6 text-stihl-orange" />
          </div>
          <h3 className={headingClasses}>Extragarantie pentru produse STIHL</h3>
        </div>
        <p className={bodyClasses}>
          <TextLink
            className={stihlLinkClasses}
            href="https://preg.stihl.com/product?lang=RO_ro&country=RO"
            external
            rel="nofollow"
            title="Inregistrati-va produsul STIHL"
          >
            Inregistrati-va produsul STIHL cu seria in termen de 30 zile si obtineti prelungirea
            termenului de garantie cu 6 luni!
          </TextLink>
        </p>
      </div>
    </div>
  )
}
